import { Global } from '@emotion/react';
import { styled } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { APP_LAYOUT_VARS } from "app/appConstants";
import { Footer } from 'layouts/common/outside/Footer';
import * as React from "react";

//////////////////////////////////////////////////////////////////////

export const OUTSIDE_LAYOUT_CONTAINER_ID = 'outsideContainer';
export const OUTSIDE_LAYOUT_SIDEBAR_ID = 'outsideSidebar';
export const OUTSIDE_LAYOUT_HEADER_ID = 'outsideHeader';
export const OUTSIDE_LAYOUT_CONTENT_ID = 'outsideContent';
export const OUTSIDE_LAYOUT_PORTAL_CONTAINER_ID = 'outsidePortalContainer';
export const OUTSIDE_LAYOUT_FOOTER = 'outsideFooter';

//////////////////////////////////////////////////////////////////////

const Container = styled('div')<IContainerProps>(({ showSideBar }) => ({
    display: "grid",
    gridTemplateColumns: "var(--sidebar-width) auto",
    gridTemplateRows: "var(--header-height) auto var(--footer-height)",
    gridTemplateAreas: showSideBar ? "'HD HD' 'SB MC' 'FO FO'" : "'HD HD' 'MC MC' 'FO FO'",
    height: "100vh",
    margin: 0,
    padding: 0,
    overflowY: "hidden",
    overflowX: "auto",
    minWidth: 600         // (Necessário para que o scroll horizontal apareça corretamente)
}));

const SidebarContainer = styled('div')(({ theme }) => ({
    gridArea: "SB",
    ...theme.extended.workArea.sideBar.container
}));

const HeaderContainer = styled('div')(({ theme }) => ({
    gridArea: "HD",
    ...theme.extended.workArea.header.container
}));

const ContentContainer = styled('div')<IContainerProps>(({ theme }) => ({
    gridArea: "MC",
    minWidth: "calc(var(--min-width) - var(--sidebar-width) - 30)",
    background: theme.extended.workArea.background,
    borderTop: "solid 1px",
    borderLeft: "solid 1px",
    borderTopColor: theme.extended.workArea.borderColor,
    borderLeftColor: theme.extended.workArea.borderColor,
    "&.hide": {
        display: "none",
    }
}));

const ContentPortalContainer = styled('div')<IContainerProps>(({ theme }) => ({
    gridArea: "MC",
    background: theme.extended.workArea.background,
    borderTop: "solid 1px",
    borderLeft: "solid 1px",
    borderTopColor: theme.extended.workArea.borderColor,
    borderLeftColor: theme.extended.workArea.borderColor,
    minWidth: "calc(var(--min-width) - var(--sidebar-width) - 30)",
    padding: theme.spacing(2),
    overflow: "auto",
    display: "none",
    "&.show": {
        display: "unset",
    }
}));

const ContentFooter = styled('div')(({ theme }) => ({
    gridArea: "FO",
    height: "32px",
    overflow: "hidden",
    ...theme.extended.workArea.footer
}));


//////////////////////////////////////////////////////////////////////

interface IProps {
    children?: React.ReactNode;
    sidebarComponent?: React.ReactNode;
    headerComponent: React.ReactNode;
}

interface IContainerProps {
    showSideBar: boolean;
}

export const MprcLayoutOutside: React.FC<IProps> = (props) => {
    const { children, sidebarComponent, headerComponent } = props;
    const theme = useTheme();
    const showSidebar = sidebarComponent != null;

    return (
        <>
            <Global
                styles={
                    {
                        body: { ...theme.extended.workArea.body },
                        ...APP_LAYOUT_VARS
                    }
                }
            />
            <Container id={OUTSIDE_LAYOUT_CONTAINER_ID} showSideBar={showSidebar}>
                {showSidebar && <SidebarContainer id={OUTSIDE_LAYOUT_SIDEBAR_ID}>{sidebarComponent}</SidebarContainer>}
                <HeaderContainer id={OUTSIDE_LAYOUT_HEADER_ID}>{headerComponent}</HeaderContainer>
                <ContentContainer id={OUTSIDE_LAYOUT_CONTENT_ID} showSideBar={showSidebar}>{children}</ContentContainer>
                <ContentPortalContainer id={OUTSIDE_LAYOUT_PORTAL_CONTAINER_ID} showSideBar={showSidebar}></ContentPortalContainer>
                <ContentFooter id={OUTSIDE_LAYOUT_FOOTER}><Footer /></ContentFooter>
            </Container>
        </>
    );
};
